/**
 * Build a link that opens the invitation screen inside the deployed web app.
 *
 * The app is currently served below `/app/`, but Vite's configured base URL is
 * the source of truth so copied links continue to work if that mount point moves.
 */
export function invitationUrl(token: string): string {
  const url = new URL(import.meta.env.BASE_URL, window.location.origin)
  url.searchParams.set('invite', token)
  return url.toString()
}
